import { DocumentContext } from '../types'
import { shallowRef } from 'vue'
import {
  documentResolutionCreate,
  documentResolutionList,
} from '@/requests/document'
import {
  DocumentResolution,
  DocumentResolutionCredentials,
} from '@/utils/types/document'
import { handleAsync, setSnackbar } from 'best-modules/plugins'

export function useResolutions({ documentId, getDocument }: DocumentContext) {
  const resolutionList = shallowRef<DocumentResolution[]>([])

  const getResolutionList = () => {
    return documentResolutionList(documentId.value).then(res => {
      resolutionList.value = res || []
    })
  }

  const createResolution = (
    reviewId: number,
    credentials: DocumentResolutionCredentials
  ) => {
    return handleAsync('documentResolutionCreate', async () => {
      await documentResolutionCreate(reviewId, credentials)
      await getDocument()
      await getResolutionList()
      setSnackbar({ text: 'Резолюцію успішно створено' })
    })
  }

  return {
    resolutionList,
    getResolutionList,
    createResolution,
  }
}
